'use strict';
// this is the content related with the content slots and assets using the templates from '/rendering/category'

module.exports.init = function () {
    // fix for IE picture tag
    if ($('picture').length > 0) {
        if (typeof Event !== 'function') {
            var evt = window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }
    }
};
